import React from 'react';
import classNames from 'classnames';
import CompleteReport from '../Survey/CompleteReport';

const ManagerReport = ({ isClevel }) => {
  const classes = classNames('manager-report', { 'margin-zero': isClevel });
  return (
    <div className={classes}>
      <CompleteReport />
    </div>
  );
};

export default ManagerReport;
